<div *ngIf="dataLoaded">
  <div class="summary-title">
    <app-title-info subTitle="Summary"></app-title-info>
  </div>
  <app-title-info [title]="projectTitle" [subTitle]="projectDescription" [styles]="stylesObj"></app-title-info>
  <app-divider-line></app-divider-line>

  <!--Solution Offering expansion panel-->
  <mat-expansion-panel hideToggle class="mat-elevation-z0 expansion-panel-div" expanded>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span class="material-icons">
          <img src="assets/images/icons/expansion-panel-up-arrow.svg" alt="Arrow" />
        </span>
        <app-configuration-summary-panel-header
          stepName="Solution Offerings"
          [recordCount]="1"
          [stepCount]="1"
        ></app-configuration-summary-panel-header>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="margin-top-1-88">
      <app-solution-offerings-step [projectDetails]="project" [summaryMode]="true"></app-solution-offerings-step>
    </div>
  </mat-expansion-panel>

  <app-divider-line></app-divider-line>

  <!--Scenario expansion panel-->
  <mat-expansion-panel hideToggle class="mat-elevation-z0 expansion-panel-div" expanded>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span class="material-icons">
          <img src="assets/images/icons/expansion-panel-up-arrow.svg" alt="Arrow" />
        </span>
        <app-configuration-summary-panel-header
          stepName="Scenarios"
          [recordCount]="scenariosCount"
          [stepCount]="2"
          addButtonName="Scenario"
        ></app-configuration-summary-panel-header>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="margin-top-1-88">
      <app-scenario-step [summaryMode]="true"></app-scenario-step>
    </div>
  </mat-expansion-panel>

  <app-divider-line></app-divider-line>

  <!--Modules expansion panel-->
  <mat-expansion-panel hideToggle class="mat-elevation-z0 expansion-panel-div" expanded>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span class="material-icons">
          <img src="assets/images/icons/expansion-panel-up-arrow.svg" alt="Arrow" />
        </span>
        <app-configuration-summary-panel-header [stepName]="'Modules'" [recordCount]="modulesCount" [stepCount]="3">
        </app-configuration-summary-panel-header>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="margin-top-1-88">
      <app-modules-step [summaryMode]="true"></app-modules-step>
    </div>
  </mat-expansion-panel>

  <app-divider-line></app-divider-line>

  <!--Team members expansion panel-->
  <mat-expansion-panel hideToggle class="mat-elevation-z0 expansion-panel-div" expanded>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span class="material-icons">
          <img src="assets/images/icons/expansion-panel-up-arrow.svg" alt="Arrow" />
        </span>
        <app-configuration-summary-panel-header
          [stepName]="'Team'"
          [recordCount]="teamMemberCount"
          [stepCount]="4"
          addButtonName="Team Members"
        >
        </app-configuration-summary-panel-header>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="margin-top-1-88">
      <app-users-step [summaryMode]="true"></app-users-step>
    </div>
  </mat-expansion-panel>

  <app-divider-line></app-divider-line>

  <!--Questionire expansion panel-->
  <mat-expansion-panel hideToggle class="mat-elevation-z0 expansion-panel-div" expanded>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span class="material-icons">
          <img src="assets/images/icons/expansion-panel-up-arrow.svg" alt="Arrow" />
        </span>
        <app-configuration-summary-panel-header [stepName]="'Questionnaire'" [recordCount]="1" [stepCount]="5">
        </app-configuration-summary-panel-header>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="margin-top-1-88">
      <app-questionnaire-step [summaryMode]="true"></app-questionnaire-step>
    </div>
  </mat-expansion-panel>

  <div class="d-flex justify-content-end gap">
    <button mat-stroked-button (click)="confirmExit()" class="cancel">Exit Configuration</button>
    <button
      mat-flat-button
      color="primary"
      (click)="saveConfiguration()"
      [disabled]="!pcDataService.projectConfigurationFormGroup.valid"
    >
      <img src="assets/images/icons/save.svg" alt="Save" />
      Save Configuration
    </button>
  </div>
</div>
